<button type="button" class="no-style-button" (click)="toggleSort()">
  <div
    class="d-flex gap-1 align-items-center px-2"
    [style.justify-content]="justifyColumnName"
    [style.height.rem]="2.25">
    <div class="column-name">{{ columnName }}</div>
    <div class="sort-arrow">
      <img [src]="sortIconSrc$ | async" alt="" aria-hidden="true" />
    </div>
  </div>
</button>
